import { __awaiter } from "tslib";
import { Tools, Core } from '../sgvizler';
/**
 *
 * @memberof gvizler
 */
export class Select {
    /**
     *
     * @param {string} elementID
     * @returns {Promise<void>}
     */
    static drawWithElementId(elementID) {
        return __awaiter(this, void 0, void 0, function* () {
            let element = document.getElementById(elementID);
            if (element) {
                yield Select.draw(element);
            }
        });
    }
    /**
     *
     * @param {Element} element
     * @param options
     * @returns {Promise<void>}
     */
    static draw(element, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let nodesOption = Select.getSelectOptions(options);
            for (let node of nodesOption) {
                element.appendChild(node.cloneNode(true));
            }
        });
    }
    /**
     * todo
     */
    static drawAll() {
        let nodesOption = Select.getSelectOptions();
        let nodesSnapshot = document.evaluate("//select[contains(@class, '" + Select.CLASS_NAME + "')]", document, null, XPathResult.UNORDERED_NODE_SNAPSHOT_TYPE, null);
        for (let i = 0; i < nodesSnapshot.snapshotLength; i++) {
            for (let node of nodesOption) {
                // @ts-ignore
                nodesSnapshot.snapshotItem(i).appendChild(node.cloneNode(true));
            }
        }
    }
    /**
     * Build url of chart's doc
     * @param {string} classFullName
     * @param {string} pathDoc
     * @returns {string} absolute or relative URL
     */
    static getChartDoc(classFullName, pathDoc) {
        let chartClass = Tools.getObjectByPath(classFullName);
        let path = '';
        if (pathDoc !== undefined) {
            path = pathDoc;
        }
        else {
            path = Core.DOCPATH;
        }
        return path + chartClass.tutorialFilename;
    }
    static getSelectOptions(options) {
        let chartClass;
        let nodeOption;
        let nodeOptgroup;
        let attrLabel;
        let attrValue;
        let attrIcon;
        let attrSub;
        let attrSelected;
        let nodes = [];
        // todo: write the option selected in the doc
        let classSelected = options && options.selected ? options.selected : this.classOfChartSelectedByDefault;
        for (let optgroup of this.charts) {
            nodeOptgroup = document.createElement('optgroup');
            attrLabel = document.createAttribute('label');
            attrLabel.value = optgroup.label;
            nodeOptgroup.setAttributeNode(attrLabel);
            for (let chart of optgroup.charts) {
                chartClass = Tools.getObjectByPath(chart);
                nodeOption = document.createElement('option');
                attrIcon = document.createAttribute('data-icon');
                attrIcon.value = chartClass.icon;
                attrSub = document.createAttribute('data-subtext');
                // todo: write the option subtext in the doc
                if (options.subtext === 'classFullName') {
                    attrSub.value = chartClass.classFullName;
                }
                else {
                    attrSub.value = chartClass.subtext;
                }
                attrValue = document.createAttribute('value');
                attrValue.value = chartClass.classFullName;
                if (classSelected === chart) {
                    attrSelected = document.createAttribute('selected');
                    nodeOption.setAttributeNode(attrSelected);
                }
                nodeOption.text = chartClass.label;
                nodeOption.setAttributeNode(attrIcon);
                nodeOption.setAttributeNode(attrSub);
                nodeOption.setAttributeNode(attrValue);
                nodeOptgroup.appendChild(nodeOption);
            }
            nodes.push(nodeOptgroup);
        }
        return nodes;
    }
}
Select.CLASS_NAME = 'sgvizler-select';
Select.classOfChartSelectedByDefault = 'bordercloud.visualization.DataTable';
/**
 * Stores the charts
 */
Select.charts = [
    {
        // optgroup
        label: 'bordercloud.visualization',
        charts: [
            'bordercloud.visualization.DataTable',
            'bordercloud.visualization.PivotTable'
        ]
    },
    // { // not ready
    //     // optgroup
    //     label: 'd3.visualization',
    //     charts: [
    //         /*'d3.visualization.AreaChart',
    //         'd3.visualization.BarChart',
    //         'd3.visualization.BubbleChart',
    //         'd3.visualization.ColumnChart',*/
    //         'd3.visualization.Line',
    //         'd3.visualization.Pie'
    //         /*,
    //         'd3.visualization.ScatterChart'
    //         */
    //     ]
    // },
    {
        // optgroup
        label: 'leaflet.visualization',
        charts: [
            'leaflet.visualization.Map'
        ]
    },
    {
        // optgroup
        label: 'google.visualization',
        charts: [
            'google.visualization.AnnotationChart',
            'google.visualization.AreaChart',
            'google.visualization.BarChart',
            'google.visualization.BubbleChart',
            'google.visualization.Calendar',
            'google.visualization.CandlestickChart',
            'google.visualization.ColumnChart',
            'google.visualization.ComboChart',
            'google.visualization.GeoChart',
            'google.visualization.Histogram',
            'google.visualization.IntervalChart',
            'google.visualization.LineChart',
            'google.visualization.Map',
            // 'google.visualization.OrgChart',
            'google.visualization.Pie',
            'google.visualization.ScatterChart',
            'google.visualization.SteppedAreaChart',
            'google.visualization.Table',
            'google.visualization.Trendline',
            'google.visualization.Timeline',
            'google.visualization.TreeMap'
        ]
    },
    {
        // optgroup
        label: 'sgvizler.visualization',
        charts: [
            'sgvizler.visualization.Table'
        ]
    }
];
//# sourceMappingURL=data:application/json;base64,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